// @flow
import React from 'react';
import PropTypes from 'prop-types';
import { FormattedMessage, intlShape } from 'react-intl';

import InspirationIcon from '../../../../common/icons/inspiration/InspirationComponent';
import ChevronIcon from '../../../../common/icons/chevron/ChevronComponent';

import './GuidelinesComponent.scss';

type Props = {
  locale: string,
  guidelinesDetails: Object,
  guidelinesCallback: Function,
};

const GuidelinesComponent = ({ locale, guidelinesDetails, guidelinesCallback }: Props): Element => {
  const { tipText, tipLink, tipPath } = guidelinesDetails;

  return (
    <div className="guidelines-component">
      <span className="guidelines-component__tip-icon">
        <InspirationIcon />
      </span>
      <span className="guidelines-component__message u-fontFamily-secondary">
        <FormattedMessage {...tipText} />
      </span>
      <a
        className="guidelines-component__link"
        target="_blank"
        href={`https://support.moo.com/hc/${locale}/sections/${tipPath}`}
        rel="noopener noreferrer"
        onClick={guidelinesCallback}
      >
        <span className="u-fontFamily-primaryMedium">
          <FormattedMessage {...tipLink} />
          <ChevronIcon />
        </span>
      </a>
    </div>
  );
};

GuidelinesComponent.displayName = 'GuidelinesComponent';

GuidelinesComponent.propTypes = {
  locale: PropTypes.string.isRequired,
  guidelinesDetails: PropTypes.shape({
    tipText: PropTypes.shape({
      id: PropTypes.string.isRequired,
      defaultMessage: PropTypes.string.isRequired,
    }).isRequired,
    tipLink: PropTypes.shape({
      id: PropTypes.string.isRequired,
      defaultMessage: PropTypes.string.isRequired,
    }).isRequired,
    tipPath: PropTypes.string.isRequired,
  }).isRequired,
  guidelinesCallback: PropTypes.func.isRequired,
};

GuidelinesComponent.contextTypes = {
  intl: intlShape.isRequired,
};

export default GuidelinesComponent;
